import { render, staticRenderFns } from "./EducationProcedure.vue?vue&type=template&id=4a92e542&"
import script from "./EducationProcedure.vue?vue&type=script&lang=js&"
export * from "./EducationProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports